import { Flex } from '@chakra-ui/react'

import { FiltersT } from 'modules/BioriskMpox/Epidemiology'
import EpiTopCountries from './Cards/EpiTopCountries'
import EpiCases from './Cards/EpiCases'
import { DataT } from '../Map/utils/types'
import EpiDiseaseByCountry from './Cards/EpiDiseasesByCountries'
import { LayerT } from '../Map/layers'

const RightSection = ({
  filters,
  dataType,
  selectCountry,
  disease,
  countryData,
  layers,
}: {
  filters: FiltersT
  dataType: string
  selectCountry: (country: string) => void
  countryData: DataT[] | undefined
  disease?: string
  layers?: {
    mapLayers: string[] | undefined
    selectedLayer: LayerT
    handleLegendClick: (newLayer: LayerT) => void
  }
}) => {
  return (
    <Flex
      flexDir={'column'}
      gap='0.5rem'
      w='350px'
      maxW='300px'
      minW='350px'
      minH={'75vh'}
    >
      <Flex h='100%'>
        <EpiTopCountries
          filters={filters}
          selectCountry={selectCountry}
          disease={disease}
        />
      </Flex>
      <Flex h='100%'>
        <EpiCases filters={filters} dataType={dataType} disease={disease} />
      </Flex>
      {disease === 'Botulism' && (
        <Flex h='100%'>
          <EpiDiseaseByCountry
            filters={filters}
            selectCountry={selectCountry}
            countryData={countryData}
            layers={layers}
          />
        </Flex>
      )}
    </Flex>
  )
}

export default RightSection
